import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export const useScrollVisibility = t0 => {
  const $ = _c(3);
  const enabled = t0 === undefined ? true : t0;
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] !== enabled) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      const handleScroll = function handleScroll() {
        setIsVisible(window.scrollY > 0);
      };
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t2 = [enabled];
    $[0] = enabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return isVisible;
};